"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var __jsx = _react.default.createElement;
var GenericPlaceholderEditConfig = {
  emptyLabel: 'Generic Placeholder',
  isEmpty: function isEmpty(props) {
    return true;
  }
};
var GenericPlaceholder = function GenericPlaceholder(_ref) {
  var placeholder = _ref.placeholder;
  return __jsx("div", {
    id: placeholder
  }, __jsx("br", null));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/genericPlaceholder')(GenericPlaceholder, GenericPlaceholderEditConfig);
exports.default = _default;